export default __webpack_public_path__ + "static/media/pescatori.d888e911.jpg";